module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.brandName && _vm.storeName) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-39px",
      "font-size": "18px"
    },
    style: (_vm.$route.name === 'upProductDescription' ? 'left: 151px;' : _vm.$route.name === 'upProductAlias' ? 'left: 103px;' : 'left: 238px;')
  }, [_vm._v("\n    " + _vm._s(_vm.brandName) + " - " + _vm._s(_vm.storeName) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left max-800 m-b-10"
  }, [_vm._l((_vm.prod_list), function(prod, pIndex) {
    return _c('div', {
      staticClass: "form block border m-y-10",
      staticStyle: {
        "vertical-align": "top"
      }
    }, [(pIndex !== 0) ? _c('div', [_c('hr', {
      staticClass: "p-b-10"
    }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between"
    }, [_c('div', {
      staticClass: "flex m-b-10"
    }, [_c('label', {
      class: ['btn btn-left', prod.type === 'choose' ? 'btn-primary' : 'btn-default'],
      attrs: {
        "for": ("choose" + pIndex)
      }
    }, [_vm._v("搜尋商品")]), _vm._v(" "), _c('label', {
      class: ['btn btn-right', prod.type === 'input' ? 'btn-primary' : 'btn-default'],
      attrs: {
        "for": ("input" + pIndex)
      }
    }, [_vm._v(_vm._s(!_vm.up ? '新增' : '編輯') + "商品")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }, {
        name: "model",
        rawName: "v-model",
        value: (prod.type),
        expression: "prod.type"
      }],
      attrs: {
        "type": "radio",
        "id": ("choose" + pIndex),
        "name": "type",
        "value": "choose"
      },
      domProps: {
        "checked": _vm._q(prod.type, "choose")
      },
      on: {
        "change": function($event) {
          return _vm.$set(prod, "type", "choose")
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }, {
        name: "model",
        rawName: "v-model",
        value: (prod.type),
        expression: "prod.type"
      }],
      attrs: {
        "type": "radio",
        "id": ("input" + pIndex),
        "name": "type",
        "value": "input"
      },
      domProps: {
        "checked": _vm._q(prod.type, "input")
      },
      on: {
        "change": function($event) {
          return _vm.$set(prod, "type", "input")
        }
      }
    })]), _vm._v(" "), (_vm.up) ? _c('div', {
      staticClass: "btn btn-danger m-b-10",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : (pIndex !== 0) ? _c('div', {
      staticClass: "m-b-10 text-right"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.prod_list.splice(pIndex, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("商品名稱\n                    "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (prod.type === 'input') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prod.input.item.name),
        expression: "prod.input.item.name"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "type": "text",
        "maxlength": "32"
      },
      domProps: {
        "value": (prod.input.item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prod.input.item, "name", $event.target.value)
        }
      }
    }) : _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品名稱",
        "show-labels": true,
        "multiple": false,
        "label": "name",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.checkVenderId(prod)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (prod.choose.item),
        callback: function($$v) {
          _vm.$set(prod.choose, "item", $$v)
        },
        expression: "prod.choose.item"
      }
    })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', [_c('div', {
      staticClass: "input-group has-feedback max-800"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v("商品料號\n                    "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (prod.type === 'input') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prod.input.item.id),
        expression: "prod.input.item.id"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "placeholder": "",
        "type": "text",
        "maxlength": "32"
      },
      domProps: {
        "value": (prod.input.item.id)
      },
      on: {
        "focusout": function($event) {
          return _vm.checkVenderId(prod)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prod.input.item, "id", $event.target.value)
        }
      }
    }) : _c('multiselect', {
      attrs: {
        "options": _vm.optionsList,
        "searchable": true,
        "allow-empty": true,
        "close-on-select": true,
        "placeholder": "請輸入商品料號",
        "show-labels": true,
        "multiple": false,
        "label": "id",
        "track-by": "id"
      },
      on: {
        "input": function($event) {
          return _vm.checkVenderId(prod)
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(props) {
          return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
        }
      }], null, true),
      model: {
        value: (prod.choose.item),
        callback: function($$v) {
          _vm.$set(prod.choose, "item", $$v)
        },
        expression: "prod.choose.item"
      }
    }), _vm._v(" "), (!_vm.up) ? _c('span', {
      staticClass: "sr-only",
      attrs: {
        "id": "inputIconStatus"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.$route.name === 'upProductAlias' || !_vm.up) ? _c('div', [_c('div', {
      staticClass: "input-group max-800"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [(_vm.up) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]) : _vm._e(), _vm._v("別名\n                  "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prod.alias_name),
        expression: "prod.alias_name"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "40px"
      },
      attrs: {
        "placeholder": "",
        "type": "text",
        "maxlength": "70"
      },
      domProps: {
        "value": (prod.alias_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prod, "alias_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'upProductDescription' || !_vm.up) ? _c('div', _vm._l((prod.prod_description_list), function(prodDes, dIndex) {
      return _c('div', {
        staticClass: "input-group m-b-10 max-800",
        staticStyle: {
          "margin-bottom": "10px"
        }
      }, [_c('span', {
        staticClass: "input-group-addon"
      }, [_vm._v("\n                  描述\n                  "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e(), _vm._v("\n                  （上限 500 字）\n                ")]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (prodDes.prod_description),
          expression: "prodDes.prod_description"
        }],
        staticClass: "form-control h-200",
        attrs: {
          "rows": "3",
          "placeholder": "",
          "type": "text",
          "maxlength": "500"
        },
        domProps: {
          "value": (prodDes.prod_description)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(prodDes, "prod_description", $event.target.value)
          }
        }
      }), _vm._v(" "), (dIndex === 0) ? _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_description_list.push({
              prod_description: ''
            })
          }
        }
      }, [_vm._v("\n                  +\n                ")]) : _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_description_list.splice(dIndex, 1)
          }
        }
      }, [_vm._v("\n                  -\n                ")])])
    }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$route.name === 'upProductDescription' || !_vm.up) ? _c('div', _vm._l((prod.prod_warning_list), function(prodDes, dIndex) {
      return _c('div', {
        staticClass: "input-group max-800",
        staticStyle: {
          "margin-bottom": "10px"
        }
      }, [_c('span', {
        staticClass: "input-group-addon"
      }, [_c('div', {
        staticClass: "warning"
      }, [_vm._v("\n                    警語\n                    "), (_vm.tab === 10) ? _c('span', [_vm._v(" (分類)")]) : _vm._e(), _vm._v("\n                    （上限 200 字）\n                  ")])]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (prodDes.prod_warning),
          expression: "prodDes.prod_warning"
        }],
        staticClass: "form-control h-200",
        attrs: {
          "rows": "3",
          "placeholder": "",
          "type": "text",
          "maxlength": "200"
        },
        domProps: {
          "value": (prodDes.prod_warning)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(prodDes, "prod_warning", $event.target.value)
          }
        }
      }), _vm._v(" "), (dIndex === 0) ? _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_warning_list.push({
              prod_warning: ''
            })
          }
        }
      }, [_vm._v("\n                  +\n                ")]) : _c('span', {
        staticClass: "c-pointer input-group-addon",
        on: {
          "click": function($event) {
            return prod.prod_warning_list.splice(dIndex, 1)
          }
        }
      }, [_vm._v("\n                  -\n                ")])])
    }), 0) : _vm._e(), _vm._v(" "), _c('br')])
  }), _vm._v(" "), (_vm.add_prod) ? _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.prod_list.push(JSON.parse(JSON.stringify(_vm.emptyProd)))
      }
    }
  }, [_vm._v("\n              ＋新增設定\n            ")])]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": _vm.goToBack
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            新增\n          ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  }, [_vm._v("\n            更新\n          ")])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-800 text-left"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 相同料號的商品會一併新增、修改")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09f55bba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/CrProductSetting.vue
// module id = 2310
// module chunks = 1